import { EBitfStoreActions } from '@common/enums';
export enum EWebStoreActions {
  NEW_WEB_ACTION = 'NEW_WEB_ACTION',
  SET_INSIGHTS = 'SET_INSIGHTS',
  DASHBOARD_SETUP_CHANGE = 'DASHBOARD_SETUP_CHANGE',
}

export const eStoreActions = { ...EBitfStoreActions, ...EWebStoreActions };
